import styles from './Eyebrow.module.css'

export default function Eyebrow({ children, className }: { children: React.ReactNode; className?: string }) {
  return <span className={[styles.eyebrow, className].filter(Boolean).join(' ')}>{children}</span>
}
